import { FC, ReactNode } from 'react';

import { ProductCardLink } from './ProductCardLink';
import { CartonProduct } from '../../types';
import { cn } from '../../utils';

interface Props {
    readonly products: CartonProduct[];
    readonly loading?: boolean;
    readonly showUniverseBadge?: boolean;
    readonly testId?: string;
    readonly manageWishlistCollections?: boolean;
    readonly childrenPosition?: 'start' | 'end';
    readonly children?: ReactNode;
    readonly className?: string;
}

export const ProductCardsGrid: FC<Props> = ({
    products,
    loading = false,
    showUniverseBadge = false,
    testId = 'products-grid',
    manageWishlistCollections = false,
    childrenPosition = 'end',
    children,
    className,
}) => (
    <div
        className={cn(
            'grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6',
            className,
        )}
        data-testid={testId}
    >
        {childrenPosition === 'start' && children}
        {products.map((product, index) => (
            <ProductCardLink
                key={product.id}
                product={product}
                loading={loading}
                eagerLoadImage={index < 8}
                showUniverseBadge={showUniverseBadge}
                manageWishlistCollections={manageWishlistCollections}
            />
        ))}
        {childrenPosition === 'end' && children}
    </div>
);
